import { Component, OnInit } from '@angular/core';
import { StaticDataService } from "../../_services/generatedServices";
import { ActivatedRoute } from "@angular/router";
import { GiftCardClaimViewModel } from "../../_models/generatedModels";
import { ToasterService } from "../../_services/toaster.service";

@Component({
  selector: 'bxl-contractor-success',
  templateUrl: 'claim-gift-card.component.html',
})
export class ClaimGiftCardComponent implements OnInit {
  initialized = false;
  oauthCode: string;
  giftCard: GiftCardClaimViewModel;
  error: boolean;
  submitComplete: Promise<{}> | undefined;

  constructor(private settings: StaticDataService, private toaster:ToasterService, private route: ActivatedRoute) {

  }

  ngOnInit(): void {
    var token = this.route.snapshot.queryParamMap.get('token');
    this.settings.getGiftCard(token).subscribe((result) => {
      this.giftCard = result;
      this.initialized = true;
    }, (error) => {
      this.error = true;
    });
  }

  public redeemGiftCard() {
    this.submitComplete = new Promise((resetButton: any, reject) => {
      this.settings.claimGiftCard(this.giftCard.id).subscribe((result) => {
        this.giftCard = result;
        resetButton(true);
        this.giftCard.claimed = true;
        this.toaster.messageDialog("Your gift card has been successfully claimed. Please check your email.","Success").subscribe();

      });
    });
  }
}
